import styles from "./ESGFramework.module.scss";
import React, { useEffect, useState, useRef } from "react";
import useOnScreen from "../../../hooks/useOnScreen";

import flow from "../../../Assets/Flow.svg";

const ESGFramework = () => {
	const ref = useRef(null);

	const [reveal, setReveal] = useState(false);
	const onScreen = useOnScreen(ref);

	useEffect(() => {
		if (onScreen) setReveal(onScreen);
	}, [onScreen]);
	return (
		<div data-scroll-section>
			<section className={styles.ESGFramework}>
				<div className="container">
					<div className={styles.imgContainer}>
						<img
							src={flow}
							alt=""
						/>
					</div>
					<p>
						Within our ESG Framework, the Responsible Investment Policy and Risk
						Management Policy, which includes sustainability risks and mandates
						the use our Sustainability Risk Management Framework, form key
						governing documents for operationalising the ESG Strategy.
						Accountability for implementing these is ensured through the
						Sustainability Governance framework, led by our management
						Sustainability Steering Committee, with specific actions assigned to
						responsible individuals and tracked by LRC leadership.
					</p>
					<div className={styles.card}>
						{[
							{
								title: "LRC ESG Strategy",
								content:
									"Drives our actions, initiatives and future direction, for both LRC as an organisation and for the assets we manage. Focuses on integrating ESG factors, identified via a 2023 materiality assessment and benchmarking exercise, into an organisational strategy aimed at enhancing portfolio performance.",
							},
							{
								title: "Responsible Investment (RI) Policy",
								content:
									"Reflects our drive to create long-term value for investors and to use our position to affect the environment and society. Our RI Policy outlines the principles and responsible investment practices that we apply across our portfolio. This Responsible Investment approach spans the investment lifecycle.",
							},
							{
								title: "Risk Management Policy",
								content:
									"Includes an outline of key sustainability risks that may affect LRC and our portfolio, and maps where they occur in the investment lifecycle, as well as setting sustainability key risk indicators and corresponding risk mitigation measures. The Policy refers in particular to the standalone Sustainability Risk Management Framework, which is an essential tool for implementing our Risk Management Policy.",
							},
						].map((item) => (
							<div key={item.title}>
								<h2>{item.title}</h2>
								<p>{item.content}</p>
							</div>
						))}
					</div>
					<div>
						<h2>Responsible Investment Lifecycle</h2>
						<p>
							Our Responsible Investment approach spans the full investment
							lifecycle, as shown in the flow chart below.
						</p>
						<div className={styles.flowchart}>
							<div className={styles.stage}>
								<div className={styles.stageHeader}>Pre-screening</div>
								<div className={styles.stageContent}>
									<ul>
										<li>
											An initial look into ESG-related risks and opportunities
											relating to a potential asset
										</li>
										<li>
											Assessing ability to support any fund-level ESG strategy
										</li>
									</ul>
								</div>
							</div>

							<div className={styles.arrow}>
								<div className={styles.arrowLine}></div>
								<div className={styles.arrowHead}></div>
							</div>

							<div className={styles.stage}>
								<div className={styles.stageHeader}>Due Diligence</div>
								<div className={styles.stageContent}>
									<ul>
										<li>
											Deeper dive into an asset's environmental, social and
											governance performance and strategy
										</li>
										<li>
											Enhance understanding of actions required for an asset to
											align with any fund-level ESG strategy
										</li>
									</ul>
								</div>
							</div>

							<div className={styles.arrow}>
								<div className={styles.arrowLine}></div>
								<div className={styles.arrowHead}></div>
							</div>

							<div className={styles.stage}>
								<div className={styles.stageHeader}>Holding Period</div>
								<div className={styles.stageContent}>
									<ul>
										<li>
											Implement actions to improve ESG credentials of an asset
										</li>
										<li>
											Ongoing data collection and reporting to inform strategy
											progress
										</li>
									</ul>
								</div>
							</div>

							<div className={styles.arrow}>
								<div className={styles.arrowLine}></div>
								<div className={styles.arrowHead}></div>
							</div>

							<div className={styles.stage}>
								<div className={styles.stageHeader}>Exit</div>
								<div className={styles.stageContent}>
									<ul>
										<li>
											Disclosure of appropriate ESG-related information on an
											asset to ensure full potential is reached
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
};

export default ESGFramework;
